<div class="row account-overview-header">
  <div class="col-xs-4 col-sm-5 col-md-7 flu-reservation-title">
    <h3 class="reservation-details">
      {{ "accountOverview.FluReservations.title" | cxTranslate }}
    </h3>
  </div>
</div>

<section class="col-12 col-xs-12 col-sm-7 col-md-12">
  <section class="row line-bottom mobileDisplayBlock">
    <!-- <section class="col-4 col-md-4 mini-card">
      <section class="three-columns-line" *ngIf="displayActiveSeasons">
        <img [src]="'../../assets/icons/'+baseSiteId+'/calendar.svg'" alt="calendar" />
        <h3 *ngIf="!fluResevartion">
          {{ activeSeasons }}
          {{ "accountOverview.FluContent.activeSeasonsopen" | cxTranslate }}
        </h3>
        <h3 *ngIf="fluResevartion">
          {{ activeSeasons }} &nbsp;
          {{ "accountOverview.FluContent.reservation" | cxTranslate }}
          {{ reservationId }}
        </h3>
        <p *ngIf="!fluResevartion">
          {{ "accountOverview.FluContent.makeyour" | cxTranslate }}
          {{ activeSeasons }}
          {{ "accountOverview.FluContent.influenzareserve" | cxTranslate }}
          {{ endDate | date: "mediumDate" }}
        </p>
        <p *ngIf="fluResevartion">
          {{ "accountOverview.FluContent.viewDetails" | cxTranslate }}
        </p>
        <button type="button" class="btn-primary w-100" (click)="onInfClick()">
          {{ fluResevartion ? viewBtnText : createBtnText }}
        </button>
      </section>
      <section *ngIf="!displayActiveSeasons">
        <p class="text-center season-inactive">{{ "accountOverview.FluContent.click" | cxTranslate }}
          <a (click)="navigatetoDb()" class="navigatetoDb-link">{{ "accountOverview.FluContent.here" | cxTranslate
            }}</a>
          {{ "accountOverview.FluContent.noactiveSeasonMsg" | cxTranslate }}
        </p>
      </section>
    </section> -->
    <section class="col-4 col-md-4 mini-card" *ngFor="let season of seasonsList">
      <section class="three-columns-line">
        <img [src]="'../../assets/icons/'+baseSiteId+'/calendar.svg'" alt="calendar" />
        <h3>
          <span *ngIf="season?.fluResevartion">Reservation &nbsp; {{season.fluOrderNumber}}</span>
          <span *ngIf="!season?.fluResevartion">Influenza season is open</span>
        </h3>
        <p>
          <span *ngIf="season?.fluResevartion">View details for your {{season?.code}} reservations.</span>
          <span *ngIf="!season?.fluResevartion" [innerHTML]="season.alertMessage"></span>
        </p>
        <button type="button" class="btn-primary w-100" (click)="onInfRedirect()">
          {{ season.fluResevartion ? viewBtnText : createBtnText }}
        </button>
      </section>
    </section>
    <section class="col-lg-4 col-md-4 col-sm-12">
      <section class="three-columns-line" *ngIf="displayActiveSeasons">
        <img [src]="'../../assets/icons/'+baseSiteId+'/calendar.svg'" alt="calendar" />
        <h3>
          Influenza vaccine locator
        </h3>
        <p>Enroll your location in the new Influenza vaccine locator and help patients find you.</p>
        <button type="button" class="btn-primary w-100" (click)="onManageSetting()">
          Manage settings
        </button>
      </section>
    </section>
    <!-- <section class="col-5 col-md-6 banner6">
      <app-flu-dashboard-banner
        [bannerComponent]="compNameAdBanner6"
      ></app-flu-dashboard-banner>
    </section> -->
  </section>
</section>